
<template>
    <vxe-modal height="80vh" ref="dialogIntensive" :title="dialogtitle" :width="dialogWidth" className="showCmdpReaderDialog" :showHeader="false"
        v-model="dialogIntensiveVisible" destroy-on-close show-zoom resize transfer draggable :fullscreen="fullscreen">
        <cmdp-workshop-intensive-sm3 :label="readerLabel" :domain="domain" :satoken="satoken" hideHelpBtn hideMessageBtn
            hideMoreBtn :sm3="sm3" :fileLabel="fileLabel" :filePath="filePath" :_orgFullName="decsisionSupportCurPara.fullName"
            :_orgEid="decsisionSupportCurPara.eid">
             
            <div slot="bar-btn">
                
            </div>

            <div slot="bar-btn">
                
                
                <span style="font-size: 16px;display: block;
                    padding: 6px 0 6px 6px;">
                      <i class="vxe-icon-square" title="最大化" v-show="!isMax"  @click="btnMaximized"></i>
                      <i class="vxe-icon-maximize" title="还原" v-show="isMax"  @click="btnMaximized"></i>
                    <i class="vxe-icon-close" @click="dialogIntensiveVisible = false" title="关闭"></i>
                </span>
            </div>
        </cmdp-workshop-intensive-sm3>

    </vxe-modal>
</template>

<script>
// import CmdpWorkshopIntensiveSm3 from  "@genesys/reader/intensive/cmdp-workshop-intensive-sm3"
export default {
    name: "dialogIntensive",
    components: {
        //  CmdpWorkshopIntensiveSm3
    },
    data() {
        return {
            dialogIntensiveVisible: false,
            readerLabel: "小智解读",
            satoken: localStorage.getItem('USER_TOKEN_VAL'),
            fileInfo: { fileName: "", filePath: "" },
            dialogtitle: "",
            dialogWidth: "600px",
            domain: `${config.serverUrl}`,
            pan_file_download: `/cmnd/ndisk/ms/v1/file_download/`,
            cat_chapter: "",
            sm3: "",
            fileLabel: "",
            decsisionSupportCurPara: JSON.parse(localStorage.getItem('decsisionSupportCurPara')) || {},
            fullscreen:false,
            isMax:false,
            filePath:'md/temp'
            // _orgFullName:"",
            // _orgEid:"",

        }
    },
    methods: {
        btnMaximized(){
            let ismax=this.$refs.dialogIntensive.isMaximized();
            if(!ismax){
                this.$refs.dialogIntensive.maximize().then(res=>{
                    this.isMax=true;
                    // console.log(res)
                })                
            }else{
                this.$refs.dialogIntensive.revert().then(res=>{
                    this.isMax=false;
                    // console.log(res)
                })  
            }
        }
        
    },

    mounted() { },

    created() {
        this.$EventBus.$on("opendialogIntensive", (e) => {
            let _params = e._params;
            if (_params) {
                this.readerLabel = _params.readerLabel;
                this.dialogtitle = _params.dialogtitle
                this.sm3 = _params.sm3;
                this.fileLabel = _params.fileLabel;
                this.fullscreen=false;
                this.filePath=_params.filePath
                // this.fileInfo= _params.fileInfo;
                // this.cat_chapter=`${this.domain}${this.pan_file_download}${_params.fileInfo.extends.output.cat_chapter.path}`
                this.dialogWidth = _params.dialogWidth;
            }
            this.dialogIntensiveVisible = true;

        })

    }

}
</script>

<style >
.showCmdpReaderDialog .vxe-modal--box .vxe-modal--body .vxe-modal--content {
    padding: 0;

}
</style>

